import {THEME} from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const JobDrawer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;
JobDrawer.displayName = 'S.JobDrawer';

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  background: ${THEME.bgSurface};
  padding: 16px 8px;
`;
StickyHeader.displayName = 'S.StickyHeader';

export const JobDrawerMain = styled.div`
  flex: 1 1 auto;
  padding: 0 8px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
JobDrawerMain.displayName = 'S.JobDrawerMain';

export const JobDrawerJobSelectionContent = styled.div`
  padding: 0 20px;
`;
JobDrawerJobSelectionContent.displayName = 'S.JobDrawerJobSelectionContent';

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 4px;
`;
LabelRow.displayName = 'S.LabelRow';

export const Label = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
`;
Label.displayName = 'S.Label';

export const VersionDescription = styled.div`
  max-width: 600px;
  max-height: 400px;
  overflow: scroll;
  font-size: 14px;
`;
VersionDescription.displayName = 'S.VersionDescription';
